import{jsx as t}from"react/jsx-runtime";import{calculateRem as e,generateUUID as n,checkIfMobileDevice as r}from"@vds-core/utilities";import{useRef as i,useState as o,useCallback as a,useEffect as u}from"react";import l,{css as c}from"styled-components";import{ColorTokens as s}from"@vds-tokens/color";const d=96,h=l.div.withConfig({displayName:"Wrapper",componentId:"VDS__sc-1d529mz-0"})`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.1s;
  outline: none;
  -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
`,f=l.div.withConfig({displayName:"Track",componentId:"VDS__sc-1d529mz-1"})`
  -webkit-user-select: none; // Disable magnifier on iOS
  -webkit-touch-callout: none;
  -webkit-user-callout: none;
  -webkit-user-drag: none;
  -webkit-user-modify: none;
  -webkit-highlight: none;
  -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
  position: relative;
  width: ${d}px;
  height: ${function({$hovered:t}){return e(t?8:4)}};
  transition:
    height 100ms linear,
    width 100ms linear,
    border-radius 100ms linear;
  box-sizing: border-box;
  border-radius: ${e(4)};
  background-color: ${function({surface:t}){return s.interactive.scrolltrack[`on${t}`].value}};

  &::before {
    min-height: 44px;
    min-width: 44px;
    width: 100%;
    height: 100%;
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
  }
  ${function({surface:t,$percentageLeft:e,$percentageRight:n,$sideClicked:r,$scrubberWidth:i,$dragging:o}){return!o&&c`
      &:active:not(:focus):not(:focus-within) {
        :after {
          position: absolute;
          border-radius: 12px;
          content: '';
          height: 100%;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          opacity: 15%;
          background: -webkit-linear-gradient(
            to ${"right"===r?"left":"right"},
            ${"light"===t?s.palette.black.value:s.palette.white.value}
              calc(
                ${"left"===r?e:n}% +
                  ${i-5}px
              ),
            ${"light"===t?s.palette.gray85.value:s.palette.gray20.value}
              calc(
                ${"left"===r?e:n}% +
                  ${i-5}px
              )
          );
          background: linear-gradient(
            to ${"right"===r?"left":"right"},
            ${"light"===t?s.palette.black.value:s.palette.white.value}
              calc(
                ${"left"===r?e:n}% +
                  ${i-5}px
              ),
            ${"light"===t?s.palette.gray85.value:s.palette.gray20.value}
              calc(
                ${"left"===r?e:n}% +
                  ${i-5}px
              )
          );
        }
      }
    `}}
`,g=l.div.withConfig({displayName:"Thumb",componentId:"VDS__sc-1d529mz-2"})`
  touch-action: manipulation;
  -webkit-user-select: none; // Disable magnifier on iOS
  -webkit-touch-callout: none;
  -webkit-user-callout: none;
  -webkit-user-drag: none;
  -webkit-user-modify: none;
  -webkit-highlight: none;
  -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
  position: absolute;
  will-change: transform;
  ${function({$enableThumbAnimation:t}){return t?c`
          -webkit-transition:
            height 100ms linear,
            left 100ms linear;
          -moz-transition:
            height 100ms linear,
            left 100ms linear;
          -o-transition:
            height 100ms linear,
            left 100ms linear;
          transition:
            height 100ms linear,
            left 100ms linear;
        `:c`
          -webkit-transition:
            height 100ms linear,
            left 0ms linear;
          -moz-transition:
            height 100ms linear,
            left 0ms linear;
          -o-transition:
            height 100ms linear,
            left 0ms linear;
          transition:
            height 100ms linear,
            left 0ms linear;
        `}}
  left: ${function({left:t}){return t}}px;
  border-radius: ${e(4)};
  height: ${function({$hovered:t}){return e(t?8:4)}};
  min-width: ${function({$hovered:t}){return e(t?20:16)}};
  width: ${function({$scrubberWidth:t}){return t}}px;
  outline: none;
  background-color: ${function({surface:t}){return s.interactive.scrollthumb[`on${t}`].value}};
  z-index: 1;

  /** HIT AREA **/
  &::before {
    min-height: 44px;
    width: 100%;
    height: 100%;
    position: absolute;
    content: '';
    cursor: pointer;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    -webkit-tap-highlight-color: transparent; // Prevent blue highlight on Android
  }
`,m=function(t){return t.targetTouches&&t.targetTouches[0]?t.targetTouches[0].clientX:t.clientX},p=function({scrubberId:e,layout:l,numberOfSlides:c,position:s,onThumbMouseUp:p,onThumbTouchEnd:b,onScrubberDrag:v,onThumbMouseDown:w,onThumbTouchStart:$,onMoveForward:k,onMoveBackward:y,surface:T,enableThumbAnimation:x,"data-track":E,"data-track-ignore":S,"data-analyticstrack":A,"data-clickstream":L,"data-sitecat-level":M,"data-sitecat-position":I,"data-sitecat-datatrack":z,"data-sitecat-cta":D}){const P=i(e||`${n()}`),X=i(`${P.current}-thumb`),C=i(`${P.current}-track`),_=i(),W=i(),N=i(),O=i(),R=i(),j=i(),B=r(),[U,V]=o(null),[F,H]=o(null),[q,G]=o(!1),[J,K]=o(!1),[Q,Y]=o(s||0),[Z,tt]=o(),[et,nt]=o(0),rt=a((function(t){var e,n;const r=m(t),i=d-(N.current||0),o=r-(null!==(e=null==Z?void 0:Z.clientX)&&void 0!==e?e:0);if(o===et)return;const a=(null!==(n=null==Z?void 0:Z.left)&&void 0!==n?n:0)+o;if(a<=0?(Y(0),nt(o)):a>=i?(Y(i),nt(o)):(Y(a),nt(o)),v){const t=a/(d-(N.current||0));v(t)}}),[Z,et,v]),it=a((function(t){_.current&&_.current.blur(),t.stopPropagation(),p&&p(t),(null==Z?void 0:Z.clientX)&&(tt(null),nt(null),K(!1))}),[Z,p]),ot=a((function(t){W.current&&clearTimeout(W.current),W.current=null,H(!1),G(!1),b&&b(t),(null==Z?void 0:Z.clientX)&&(tt(null),nt(null),K(!1))}),[Z,b]),at=a((function(t){_.current&&_.current.blur(),it(t)}),[it]),ut=a((function(t){_.current&&_.current.blur(),t.stopPropagation();const e=m(t);w&&w(t),tt({clientX:e,left:Q}),K(!0)}),[w]),lt=a((function(t){G(!0),W.current=setTimeout((function(){H(!0)}),100),$&&$(t);const e=m(t);tt({clientX:e,left:Q}),K(!0)}),[$]),ct=a((function(t){var e,n;const r=null===(n=null===(e=t.target)||void 0===e?void 0:e.getBoundingClientRect())||void 0===n?void 0:n.left,i=m(t)-Math.round(r);V(void 0===Q||i<1.4*Q?"left":"right")}),[Q]),st=function(t){return"left"===U?function(t){y&&y(t)}(t):function(t){k&&k(t)}(t)},dt=function(){return H((function(t){return!t}))};return u((function(){var t;_.current="undefined"!=typeof document&&document.getElementById(X.current),N.current=d/parseInt(null==c?void 0:c.toString(),10)*parseInt(null!==(t=null==l?void 0:l.toString())&&void 0!==t?t:"",10),O.current=Q/d*100,R.current=100-O.current-N.current,j.current=d-N.current}),[]),u((function(){const t=ot,e=at;return"undefined"!=typeof window&&(window.addEventListener("touchend",t),window.addEventListener("mouseup",e)),function(){"undefined"!=typeof window&&(window.removeEventListener("touchend",t),window.removeEventListener("mouseup",e))}})),u((function(){var t;N.current=d/parseInt(c.toString(),10)*parseInt(null!==(t=null==l?void 0:l.toString())&&void 0!==t?t:"",10),j.current=d-N.current}),[l,c]),u((function(){(null!=s?s:0)<=j.current&&!1===J&&Y((null!=s?s:1)*j.current)}),[s,J]),u((function(){const t=rt;if(J)return"undefined"!=typeof window&&(window.addEventListener("mousemove",t,!0),window.addEventListener("touchmove",t,!0)),function(){"undefined"!=typeof window&&(window.removeEventListener("mousemove",t,!0),window.removeEventListener("touchmove",t,!0))}}),[J]),u((function(){O.current=Q/d*100,R.current=100-O.current-N.current}),[Q]),t(h,Object.assign({},!B&&{onMouseEnter:dt,onMouseLeave:dt},{children:t(f,{className:"scrollbar-track",id:C.current,$hovered:F,$scrubberWidth:N.current,$percentageRight:R.current,$percentageLeft:O.current,$sideClicked:U,onMouseDown:ct,onMouseUp:st,onTouchStart:ct,onTouchEnd:st,surface:T,$dragging:q,children:t(g,{id:X.current,onTouchStart:lt,onTouchEnd:ot,onMouseDown:ut,onMouseUp:it,$enableThumbAnimation:x,$hovered:F,surface:T,$scrubberWidth:N.current,left:Q,"data-track":E,"data-track-ignore":S,"data-analyticstrack":A,"data-clickstream":L,"data-sitecat-level":M,"data-sitecat-position":I,"data-sitecat-datatrack":z,"data-sitecat-cta":D})})}))};p.defaultProps={surface:"light",enableThumbAnimation:!1};export{p as default};
